
import { useLetPassAccountTracked } from "presentation/store/LetPassAccount/LetPassAccountProvider";
import { SliderPanel } from "veronica-ui-component/dist/component/core";
import LetPassAccountEditPanel from "./LetPassAccountEditPanel";
import LetPassAccountTablePanel from "./LetPassAccountTablePanel";

export const LetPassAccountRightPanel: React.FC = () => {
    const [letPassAccountState] = useLetPassAccountTracked();
    const { isShowEditPanel } = letPassAccountState;

    return <>
        <div className={`main-comp-wrapper${(isShowEditPanel) ? '' : ' im-hide-side-form-draggable'}`}>
            <SliderPanel
                isOpen={true}
                draggable={false}
                leftSectionWidth={isShowEditPanel ? '50%' : '100%'}
                rightSectionWidth={isShowEditPanel ? "50%" : '0%'}
                leftChildren={<LetPassAccountTablePanel />}
                rightChildren={<LetPassAccountEditPanel />}
            />
        </div>
    </>
}